import { combineReducers } from "redux";
import {
    authReducer,
    verifyInviteReducer,
    userResendInviteReducer,
    verifyOptReducer, sendOtpReducer
} from "./authReducer";
import { onboardingReducer, referralReducer, decisionReducer } from "./onboardingReducer";
import {
    getServiceListReducer,
    getSpecializationsListReducer,
    getDocumentTypesListReducer,
    uploadFileReducer,
    removeFileReducer,
    notificationReducer,
    getRoleReducer,
    getStudioListReducer,
    getAlbumTemplatesReducer,
    getNotificationCount,
    listNotificationsReducer,
    markAllReadReducer,
    markOneReadReducer,
    fetchNotificationSettingsReducer,
    updateNotificationSettingsReducer,
    setLoading,
    getRoutes,
    accessibleRoutes,
    viewNotificationReducer,
    kycNameCheckReducer,
    generateSessionSasReducer
} from "./commonReducer";
import { editUserReducer, memberListReducer, photographerListReducer, userReducer, viewUserReducer } from "./userReducer";
import {
    userListReducer,
    inviteUserReducer,
    deleteUserReducer,
    processDeleteRequestReducer,
    deleteRequestsListReducer,
    revokeUserReducer,
    submitUpdateRequestReducer,
    processUpdateRequestReducer,
    updateRequestsListReducer,
    viewKycReducer
} from "./userReducer";
import { termsAndConditionReducer, termsOfServiceReducer, privacyPolicyReducer } from "./termsAndConditionReducer";
import { createCookiesReducer, getCookiesReducer, updateCookiesReducer } from "./cookiesReducer";
import {
    assignMemberToEventsReducer,
    closeEventReducer,
    createEventReducer,
    eventListReducer,
    getEventsWithEnquiriesReducer,
    normalizedEventReducer,
    updateEventReducer,
    viewEventReducer,
    updateEventStageReducer,
} from "./eventReducer";
import {
    studioListReducer,
    updateStudioReducer,
    viewStudioReducer,
    studioCityReducer,
    deactivateStudioReducer,
    reactivateStudioReducer,
} from "./studioReducer";
import availabilityReducer from "./availabilityReducer";
import attendanceReducer from "./attendanceReducer";
import { getDashboardReducer } from "./dashboardReducer";
import { listMediaReducer, mediaStatusReducer, mediaUploadReducer } from "./mediaReducer";
import { createEnquiryReducer, deleteEnquiryReducer, listEnquiryReducer, viewEnquiryReducer, updateEnquiryReducer } from "./enquiryReducer";
import paymentReducer from "./paymentReducer";
import financialReducer from "./financialReducer";
import eventAlbumSelectionReducer from "./eventAlbumSelectionReducer";
import { albumUploadReducer } from "./eventAlbumSelectionUploadReducer";
import { albumBuilderReducer, createBackgroundSas } from "./albumBuilderReducer";
import eventAlbumReducer from "./eventAlbumReducer";
import { getCommentsReducer, addCommentReducer, editCommentReducer } from "./commentsReducer";
import { planList, planCreate, viewPlan, updatePlan } from "./planReducer";
import { subscriptionPlanList, subscriptionSummary, subscriptionHistory, prepareSubscriptionCheckout, cancelSubscription , checkSubscriptionStatus} from "./subscriptionReducer"
import { viewSubscription, updateSubscription } from "./subscriptionReducer";
import { bulkRouteInsert, updateRoutes } from "./routesReducer";

const rootReducer = combineReducers({
    authReducer,
    sendOtpReducer,
    onboardingReducer,
    setLoading,
    referralReducer,
    decisionReducer,
    getServiceListReducer,
    getSpecializationsListReducer,
    getDocumentTypesListReducer,
    uploadFileReducer,
    removeFileReducer,
    getRoutes,
    accessibleRoutes,
    notificationReducer,
    verifyOptReducer,
    getRoleReducer,
    getStudioListReducer,
    verifyInviteReducer,
    userResendInviteReducer,
    user: userReducer,
    editUserReducer,
    viewUserReducer,
    userListReducer,
    memberListReducer,
    photographerListReducer,
    inviteUserReducer,
    deleteUserReducer,
    processDeleteRequestReducer,
    deleteRequestsListReducer,
    revokeUserReducer,
    submitUpdateRequestReducer,
    processUpdateRequestReducer,
    updateRequestsListReducer,
    termsAndConditionReducer,
    termsOfServiceReducer,
    privacyPolicyReducer,
    viewKycReducer,

    createCookiesReducer,
    getCookiesReducer,
    updateCookiesReducer,

    createEventReducer,
    eventListReducer,
    assignMemberToEventsReducer,
    viewEventReducer,
    updateEventReducer,
    closeEventReducer,
    normalizedEvent: normalizedEventReducer,
    getEventsWithEnquiriesReducer,
    updateEventStageReducer,

    studioListReducer,
    viewStudioReducer,
    updateStudioReducer,
    studioCityReducer,
    deactivateStudioReducer,
    reactivateStudioReducer,
    availability: availabilityReducer,
    attendance: attendanceReducer,

    getDashboardReducer,

    mediaUpload: mediaUploadReducer,
    listMediaReducer,
    mediaStatusReducer,

    createEnquiryReducer,
    listEnquiryReducer,
    deleteEnquiryReducer,
    viewEnquiryReducer,
    updateEnquiryReducer,

    payment: paymentReducer,

    getNotificationCount,
    listNotificationsReducer,
    markAllReadReducer,
    markOneReadReducer,
    fetchNotificationSettingsReducer,
    updateNotificationSettingsReducer,
    financial: financialReducer,
    viewNotificationReducer,
    kycNameCheckReducer,
    generateSessionSasReducer,

    getAlbumTemplatesReducer,
    albumSelection: eventAlbumSelectionReducer,
    albumUpload: albumUploadReducer,
    albumBuilder: albumBuilderReducer,
    eventAlbum: eventAlbumReducer,
    createBackgroundSas,

    getCommentsReducer,
    addCommentReducer,
    editCommentReducer,

    planList,
    planCreate,
    viewPlan,
    updatePlan,

    subscriptionPlanList,
    subscriptionSummary,
    subscriptionHistory,
    prepareSubscriptionCheckout,
    cancelSubscription,
    viewSubscription,
    updateSubscription,
    checkSubscriptionStatus,

    bulkRouteInsert,
    updateRoutes


});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
